/* eslint-disable func-names */
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

export const addConsignee = async function (data) {
  try {
    return await tmsMdmAxiosInstance.post('/consignee', { data });
  } catch (error) {
    throw error;
  }
};
